import { AvisInitialTypeLight } from './AvisInitialTypeLight';
import { TypeFNSSimpleDescMarche2 } from './TypeFNSSimpleDescMarche2';
export class Annulation {
	public infosAnnulation: string;

	public avisInitial: AvisInitialTypeLight;

	public natureMarche: TypeFNSSimpleDescMarche2;

	constructor() {
		this.infosAnnulation = '';
		this.avisInitial = new AvisInitialTypeLight();
		this.natureMarche = new TypeFNSSimpleDescMarche2();
	}
}
